import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconFilledHome: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      {...props}
      fill="none"
    >
      <path
        d="M6.63478 18.7733V15.7156C6.63478 14.9351 7.27217 14.3023 8.05844 14.3023H10.9326C11.3102 14.3023 11.6723 14.4512 11.9393 14.7163C12.2063 14.9813 12.3563 15.3408 12.3563 15.7156V18.7733C12.3539 19.0978 12.4821 19.4099 12.7124 19.6402C12.9427 19.8705 13.2561 20 13.5829 20H15.5438C16.4596 20.0023 17.3388 19.6428 17.9872 19.0008C18.6356 18.3588 19 17.487 19 16.5778V7.86686C19 7.13246 18.6721 6.43584 18.1046 5.96467L11.434 0.675869C10.2737 -0.251438 8.61111 -0.221498 7.48539 0.746979L0.967012 5.96467C0.372741 6.42195 0.0175523 7.12064 0 7.86686V16.5689C0 18.4639 1.54738 20 3.45617 20H5.37229C6.05123 20 6.603 19.4562 6.60792 18.7822L6.63478 18.7733Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default IconFilledHome;
